import { RequestDto } from 'generated/request-backend';

export interface RequestImpactTotals {
    revenue: number;
    devices: number;
}

export function getRequestImpactTotals(
    request: Pick<
        RequestDto,
        'customerImpacts' | 'msxCurrentTotalRevenue' | 'msxTotalRevenue' |
        'msxCurrentTotalDeviceCount' | 'msxTotalDeviceCount'
    >,
): RequestImpactTotals {
    if (request.customerImpacts?.length) {
        return request.customerImpacts.reduce(
            (totals, impact) => ({
                revenue: totals.revenue + Number(impact.msxRevenue || 0),
                devices: totals.devices + Number(impact.msxDeviceCount || 0),
            }),
            { revenue: 0, devices: 0 },
        );
    }

    return {
        revenue: request.msxCurrentTotalRevenue ?? request.msxTotalRevenue ?? 0,
        devices: request.msxCurrentTotalDeviceCount ?? request.msxTotalDeviceCount ?? 0,
    };
}
